import { render, staticRenderFns } from "./PersonalPreferencesForm.vue?vue&type=template&id=db125f58&scoped=true&"
import script from "./PersonalPreferencesForm.vue?vue&type=script&lang=ts&"
export * from "./PersonalPreferencesForm.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalPreferencesForm.vue?vue&type=style&index=0&id=db125f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db125f58",
  null
  
)

export default component.exports